import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Input, message } from "antd";
import React, { useState } from "react";
import { useMutation } from "react-query";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { isEmpty } from "../../lib/helpers/helpers";
import { btnStyle, inputStyle } from "../../lib/styles/styleLibrary";
import { createPlanTag } from "../../redux/actions/plans";

const AddNewTag = (props) => {
	const {
		handleCancel = () => {
			return null;
		},
        refetch=()=>{
            return null
        },
		id,
	} = props;

	const [tag, setTag] = useState({
		weddingId: id,
		name: "",
	});

	const { mutateAsync: createTag, isLoading } = useMutation(createPlanTag);

	const handleCreate = async () => {
		if (isEmpty(tag.name)) {
			return message.error("Tag name cannot be empty!");
		}
		try {
			const response = await createTag(tag);
			console.log("\nCreate tag res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				return message.error(
					`${response.data.errors.title},\n ${response.data.errors.message}`
				);
			}
			message.success(`${response.data.message}, tag created!`);
			return setTimeout(() => {
                refetch()
				handleCancel();
				setTag({ ...tag, name: "" });
			}, 1000);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<>
			<div
				tw="h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={handleCancel}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>
			<h3
				tw="font-semibold tracking-wider text-center w-full"
				style={{ fontSize: "18px" }}>
				Create Tag
			</h3>
			<div tw="mt-8">
				<Input
					placeholder="What do you wish to call your tag?"
					type="text"
					css={inputStyle}
					value={tag.name}
					onChange={(e) =>
						setTag({
							...tag,
							name: e.target.value,
						})
					}
					tw="w-full text-xs! px-3 py-6 rounded-md"
				/>
			</div>
			<div tw="mt-8 mb-8">
				<Button
					loading={isLoading}
					css={btnStyle}
					tw="rounded-lg"
					onClick={handleCreate}>
					Create
				</Button>
			</div>
		</>
	);
};
export default AddNewTag;
